import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import store, { history } from './store'

import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import ReduxToastr from 'react-redux-toastr'

// import CacheBuster from './CacheBuster';

import { App } from './app'


// import 'sanitize.css/sanitize.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/css/bootstrap-rtl.css'
// import 'font-awesome/css/font-awesome.min.css'
// import '@mdi/font/css/materialdesignicons.min.css'

import './assets/css/material-dashboard.css'
import './assets/css/leaflet.css'
import './assets/css/indicator.css'
// import './assets/css/rodal.css'
import './assets/css/main.css'
import './assets/css/menu.css'

// import './assets/js/jquery-2.2.4.min.js'
// import './assets/js/bootstrap.min.js'
// import './assets/js/material-dashboard.js'

const target = document.querySelector('#root')

render(
  // <CacheBuster>
  //   {({ loading, isLatestVersion, refreshCacheAndReload }) => {
  //     if (loading) return null;
  //     if (!loading && !isLatestVersion) {
  //       refreshCacheAndReload();
  //     }

  //     return (
        <Provider store={store}>
          <div>
            <ConnectedRouter history={history}>
              <div>
                <App />
              </div>
            </ConnectedRouter>
            <ReduxToastr
              timeOut={5000}
              newestOnTop={false}
              preventDuplicates
              position="top-center"
              transitionIn="fadeIn"
              transitionOut="fadeOut"
              progressBar
              closeOnToastrClick
            />
          </div>
        </Provider>
  //     );
  //   }}
  // </CacheBuster>
  ,
  target
)
